import React, { useState, useEffect } from 'react';
import './PointCollect.css';
import { useNavigate } from 'react-router-dom';
import en from '../locales/eng.json';
import th from '../locales/th.json';
import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';
import CONFIG from '../config';

import getProfileImage from '../utils/getProfileImage';

function PointCollect() {
  const navigate = useNavigate();
  const storedData = localStorage.getItem('userData');
const [mode, setMode] = useState('QR'); // or 'BARCODE'
const [userData, setUserData] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
const [language, setLanguage] = useState(() => {
  return localStorage.getItem('language') || 'TH';
});
const [t, setT] = useState(language === 'EN' ? en : th);

const profileImage = getProfileImage()

useEffect(() => {
  localStorage.setItem('language', language);
  setT(language === 'EN' ? en : th);
}, [language]);


useEffect(() => {
  const fetchUserData = async () => {
    try {
      const res = await fetch(`${CONFIG.API_BASE_URL}/lineuser/fetch_user_data?line_user_id=`+ localStorage.getItem('line_user_id'));
      const result = await res.json();

      if (result?.content?.data) {
        setUserData(result.content.data);
      } else {
        throw new Error("Invalid user data format");
      }
    } catch (e) {
      console.error("Failed to fetch user data:", e);
      navigate('/'); // Navigate away if error
    }
  };

  fetchUserData();
}, [navigate]);

  return (
    <div style={{ backgroundColor: ' #FFFFFF'}}>
      <div className="point-header-gradient">
  <img onClick={() => navigate('/')} src="/assets/logo-ujoy.png" alt="logo" className="logo-ujoy" />
  <div className="right-section">
  <div className="lang-selector">
  <button
    className={`lang-button ${language === 'TH' ? 'active' : ''}`}
    onClick={() => setLanguage('TH')}
  >
    TH
  </button>
  |
  <button
    className={`lang-button ${language === 'EN' ? 'active' : ''}`}
    onClick={() => setLanguage('EN')}
  >
    EN
  </button>
</div>

    {/* <img src="/assets/avartar.png" alt="avatar" className="profile-avatar" /> */}
            {showMenu ? 
          <div >
           
 {showMenu && (
  <>
   <img
  onClick={() => navigate('/profile')}
  src="/assets/mascot-full.png"
  alt="avatar"
  style={{ position: 'relative', zIndex: 9998 }} // ADD position
/>
    <div className="menu-overlay" onClick={() => setShowMenu(false)}></div>
    <div className="menu-popup-wrapper">
      <div className="menu-popup">
        <div className="menu-item" onClick={() => { navigate('/my-coupon'); setShowMenu(false); }}>
          <img src="/assets/icon-coupon.png" alt="coupon" />
          <span>คูปองของฉัน</span>
        </div>
        <div className="menu-item" onClick={() => { navigate('/point-redeem'); setShowMenu(false); }}>
          <img src="/assets/icon-redeem.png" alt="redeem" />
          <span>แลกคะแนน</span>
        </div>
        <hr className="dashed-line" />
        <div className="menu-item" onClick={() => { navigate('/point-history'); setShowMenu(false); }}>
          <img src="/assets/icon-points.png" alt="points" />
          <span>คะแนนสะสม</span>
        </div>
        <hr className="dashed-line" />
      </div>
    </div>
  </>
)}


  </div>
  : <div><img
  onClick={() => navigate('/profile')}
  src={
    userData?.line_image_url
      ? userData.line_image_url
      : "/assets/avartar.png"
  }
  alt="avatar"
  className="profile-avatar"
/></div>}

  </div>
    </div>

    <div className="point-header-bar">
    <button className="back-button" onClick={() => navigate(-1)}>
  <img src="/assets/arrow_back.png" alt="Back" className="back-icon" />
</button>
  <span className="point-header-title">{t.pointcollect.pointcollect}</span>
</div>


<div className="member-summary-section">
  <div className="member-left">
    <img src="/assets/cloud.png" alt="cloud" className="cloud-avatar" />
    <span className="member-id">UF{userData?.phone || 'XXXXXXX'}</span>
  </div>
  <button className="redeem-button-pointcollect" onClick={() => navigate('/point-redeem')}>
    <img src="/assets/rewarded_ads-white.png" alt="icon" />
    {t.pointcollect.redeem}
  </button>
</div>

<div className="points-center-section">
  <p className="points-center-title">{t.pointcollect.present_points}</p>
  <div className="points-center-value">
    <span>{userData?.point?.toLocaleString() || '0'}</span>
    <img src="/assets/coin.png" alt="coin" style={{width: '40px', height: '40px'}}/>
  </div>
  <p className="points-expire-note">{userData?.point?.toLocaleString() || '0'} {t.pointcollect.points}</p>
</div>

<div className="tab-toggle-section">
  <button
    className={`tab-button ${mode === 'QR' ? 'active' : ''}`}
    onClick={() => setMode('QR')}
  >
    <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>QR Code</div>
  </button>
  <button
    className={`tab-button ${mode === 'BARCODE' ? 'active' : ''}`}
    onClick={() => setMode('BARCODE')}
  >
    <div style={{ paddingLeft: '20px', paddingRight: '20px' }}>Barcode</div>
  </button>
</div>

<div style={{fontWeight: "bold", color: "#079AAE"}}>{t.pointcollect.show_qr}</div>

{mode === 'QR' && (
  <div className="qr-mode-wrapper-pointcollect">
    {userData?.phone ? (
      <>
        <div className="qr-card-pointcollect">
          <div className="qr-image-wrapper">
            <QRCodeSVG value={userData.phone} size={200} />
            <img
              src="/assets/logo-qr.png"
              alt="QR Logo"
              className="qr-logo-overlay"
            />
             <p className="member-id-label">Member ID&nbsp; UF{userData.phone}</p>
          </div>
        </div>
       
      </>
    ) : (
      <p>Loading QR...</p>
    )}
  </div>
)}


{mode === 'BARCODE' && (
  <div className="barcode-mode-section" style={{ textAlign: 'center', marginTop: 20 }}>
    {userData?.phone ? (
      <>
        <div style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '16px',
          display: 'inline-block',
          boxShadow: '0px 10px 25px rgba(0, 0, 0, 0.08)'
        }}>
          <Barcode value={userData.phone} width={2} height={100} fontSize={16} />
          <p className="member-id-label">Member ID&nbsp; UF{userData.phone}</p>
        </div>
        
      </>
    ) : (
      <p>Loading Barcode...</p>
    )}
  </div>
)}

<br/>
<div style={{color: '#A5A5A5'}}>{t.pointcollect.update_points}</div>

<br/>



    </div>
  );
}

export default PointCollect;
